import Layout from 'src/components/Layout';
import SelectACompanyPlaceholder from 'src/components/SelectACompanyPlaceholder';
import ViewCalendarYearContextProvider from 'src/sections/view_periods/ViewCalendarYearContext';
import ViewPeriodsNavBar from 'src/sections/view_periods/ViewPeriodsNavBar';
import ViewPeriodsTable from 'src/sections/view_periods/ViewPeriodsTable';

const ViewPeriods = () => (
  <ViewCalendarYearContextProvider>
    <ViewPeriodsNavBar />
    <Layout>
      <SelectACompanyPlaceholder display={<ViewPeriodsTable />} />
    </Layout>
  </ViewCalendarYearContextProvider>
);

export default ViewPeriods;
